import { FormControl, FormGroup, Validators } from '@angular/forms';
import { classes } from 'polytype';

import { BaseObjectModel } from '@app/shared/models/base.model';

export type WorkflowResponsibilityFormGroup = ReturnType<
    typeof WorkflowResponsibilityModel.getResponsibilityForm
>;

export class WorkflowResponsibilityModel extends classes(BaseObjectModel) {
    // Auditable:
    readonly createdBy?: null | string;
    readonly createdDate?: string;
    readonly lastModifiedBy?: null | string;
    readonly lastModifiedDate?: string;

    isRestricted: boolean;
    users: string[];
    teams: string[];
    workflowId: number;

    static getResponsibilityForm(data: any) {
        const form = new FormGroup({
            id: new FormControl(data?.id || null),
            name: new FormControl(data?.name || 'New Responsibility', Validators.required),
            workflowId: new FormControl(data?.workflowId || null),
            isRestricted: new FormControl(data?.isRestricted ?? false),
            users: new FormControl(data?.users || []),
            teams: new FormControl(data?.teams || []),
        });

        // FIXME: Observable is never being unsubscribed
        form.controls.isRestricted.valueChanges.subscribe(isRestricted => {
            if (!isRestricted) {
                form.patchValue({
                    users: [],
                    teams: [],
                });
            }
            form.updateValueAndValidity();
        });

        return form;
    }
}
